import DOMPurify from 'dompurify'
import { html } from './html'

const responsivity = {
  mixins: [html],
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    mobileView() {
      return this.windowWidth <= 768
    },
    tabletView() {
      return this.windowWidth > 768 && this.windowWidth <= 1024
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    calculateNumbersOfLines(firstbreakpoint, secondbreakpoint, thirdbreakpoint) {
      if (window.innerHeight >= 950) {
        return thirdbreakpoint
      } else if (window.innerHeight < 950 && window.innerHeight > 850) {
        return secondbreakpoint
      } else if (window.innerHeight <= 850) {
        return firstbreakpoint
      }
    },
    getNWordsFromString(str, nbrWords = 100, filterHtml = false) {
      let text = str
      if (filterHtml) {
        text = this.convertToPlainWithSpaces(text)
      }
      const wordsCount = text.split(' ').filter(word => word !== '').length
      if (wordsCount < nbrWords) {
        return text.replace(/\n+$/, '')
      }
      const firstNWords = text.split(' ').slice(0, nbrWords).join(' ') + '...'
      return firstNWords.replace(/\n+$/, '')
    },
    getTooltipCorrectString(str) {
      const lineBreakCount = (str.match(/\n/g)).length
      if (lineBreakCount > 10) {
        return str.substr(0, this.indexOfNth(str, '\n', 10)) + '...'
      }
      return this.getNWordsFromString(str, 30)
    },
    indexOfNth(string, char, nth, fromIndex = 0) {
      const indexChar = string.indexOf(char, fromIndex)
      if (indexChar === -1) {
        return -1
      } else if (nth === 1) {
        return indexChar
      } else {
        return this.indexOfNth(string, char, nth - 1, indexChar + 1)
      }
    },
    hasSomeParentTheClass(element, classname) {
      if (element && classname && element.classList && element.classList !== '' && element.classList.contains(classname)) return true
      if (element.parentNode) return element.parentNode && this.hasSomeParentTheClass(element.parentNode, classname)
      return false
    },
    convertToPlainWithSpaces(html) {
      let htmlCleaned = html
      // remove code brakes and tabs
      htmlCleaned = htmlCleaned.replace(/\n/g, '')
      htmlCleaned = htmlCleaned.replace(/\t/g, '')

      // keep html brakes and tabs
      htmlCleaned = htmlCleaned.replace(/<\/td>/g, ' ')
      htmlCleaned = htmlCleaned.replace(/<\/table>/g, ' ')
      htmlCleaned = htmlCleaned.replace(/<\/tr>/g, ' ')
      htmlCleaned = htmlCleaned.replace(/<\/p>/g, '  ')
      htmlCleaned = htmlCleaned.replace(/<\/div>/g, ' ')
      htmlCleaned = htmlCleaned.replace(/<\/h>/g, ' ')
      htmlCleaned = htmlCleaned.replace(/<br>/g, ' ')
      htmlCleaned = htmlCleaned.replace(/<br( )*\/>/g, ' ')
      const tempDivElement = document.createElement('div')
      tempDivElement.innerHTML = htmlCleaned
      return tempDivElement.textContent || tempDivElement.innerText || ''
    },
    /**
     * Escapes plain text for safe embedding into HTML strings before DOMPurify / v-dompurify-html.
     * Use for user-entered plain fields (event title, location, bodyText→HTML synthesis) — not for rich HTML bodies.
     * Escaped entities render back as visible characters (e.g. &lt; displays as <).
     */
    escapeHtml(value: string): string {
      if (value == null || typeof value !== 'string') {
        return ''
      }
      return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },

    /**
     * Decodes HTML entities only when present, without DOM parsing.
     * Preserves raw `<>` / `<word>` in the same string (COOZ-15836 / Bugbot).
     */
    decodeHtmlEntitiesIfNeeded(value: string): string {
      return this.decodeHtmlEntitiesSafe(value)
    },

    /**
     * Encodes angle brackets around email-like strings so DOMPurify does not strip them as tags.
     * E.g. "Outlook.com Team<member_services@outlook.com>" → "Outlook.com Team&lt;member_services@outlook.com&gt;"
     * Uses [^\s>]* so real tags (e.g. <a href="mailto:...">) are not matched.
     */
    protectAngleBracketedEmails(htmlString: string): string {
      if (!htmlString || typeof htmlString !== 'string') {
        return htmlString || ''
      }
      return htmlString.replace(/<([^\s>]*@[^\s>]*)>/g, '&lt;$1&gt;')
    },

    /**
     * Sanitizes HTML for safe display. Preserves structure and angle-bracketed emails.
     * Used by: PrintMessage (email bodyHtml), MessagesView (message HTML), CalendarOverview/DashboardTables/ContactEventCard (event descriptions).
     */
    sanitizeHtml(htmlString) {
      if (!htmlString) {
        return '-'
      }
      const withProtectedEmails = this.protectAngleBracketedEmails(htmlString)
      return DOMPurify.sanitize(withProtectedEmails || '')
    }
  }
}

export { responsivity }
